export default "__VITE_ASSET__e6ad237b__"